import React from "react";
import { useTranslation } from "react-i18next";

function Detail() {
  const { t } = useTranslation();

  return (
    <div className="mt-5 flex flex-col gap-2.5 text-sm text-tertiary pc:mt-20 pc:flex-row pc:gap-5">
      <div className="flex flex-wrap gap-1 pc:gap-5">
        <span>{t("company.tune")}</span>
        <span>{t("company.ceo")}</span>
        <span>{t("company.address")}</span>
        <span>{t("company.fax")}</span>
        <span>{t("company.info")}</span>
      </div>
    </div>
  );
}

export default Detail;
